// src/pages/Ventas/Planes.js
import React, { useState, useEffect } from "react";
import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Paper } from "@mui/material";
import axios from "axios";
import { getAuthData } from "../utils/auth";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL;

const Planes = () => {
    const [tipo, setTipo] = useState("productos");
    const [mapaUrl, setMapaUrl] = useState(null);

    const auth = getAuthData();
    const token = auth?.token;

    useEffect(() => {
        let objectUrl = null;

        const fetchMapa = async () => {
            if (!token) return;
            try {
                const response = await axios.get(
                    `${apiUrl}/api/planes/imagen/${tipo}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                        responseType: "blob"
                    }
                );

                objectUrl = URL.createObjectURL(response.data);
                setMapaUrl(objectUrl);
            } catch (error) {
                console.error("Error al obtener el documento del plan:", error);
                toast.error(`No se pudo cargar el documento de ${tipo}.`);
                setMapaUrl(null);
            }
        };

        fetchMapa();

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [tipo, token]);

    return (
        <Box
            sx={{
                margin: "0 auto",
                padding: 3,
                boxShadow: 3,
                backgroundColor: "#ffffff",
                borderRadius: 2,
            }}
        >
            <Typography
                sx={{
                    fontFamily: "Bakbak One, sans-serif",
                    color: "#0A4575",
                    mb: 2
                }}
                variant="h5"
            >
                Planes de Productos y Servicios
            </Typography>

            <Box>
                <FormControl variant="outlined" size="small" sx={{ mb: 2, minWidth: 200 }}>
                    <InputLabel>Seleccione Tipo de Plan</InputLabel>
                    <Select
                        value={tipo}
                        onChange={(e) => setTipo(e.target.value)}
                        label="Seleccione Tipo de Plan"
                        sx={{ boxShadow: 3 }}
                    >
                        <MenuItem value="productos">Productos</MenuItem>
                        <MenuItem value="servicios">Servicios</MenuItem>
                    </Select>
                </FormControl>

                {mapaUrl ? (
                    <iframe
                        src={mapaUrl}
                        title={`Documento de ${tipo}`}
                        style={{ width: "100%", height: "86vh", border: "none" }}
                    />
                ) : (
                    <Typography variant="body1" sx={{ color: "gray", fontStyle: "italic", textAlign: "center", padding: 4 }}>
                        Seleccione una opción o verifique que el documento exista en el servidor.
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default Planes;
